module.exports = __webpack_public_path__ + "img/jdjf.da0d7a72.png";